module.exports = __webpack_public_path__ + "img/flat_family.f41e2f43.jpg";